//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'

import slugify from 'slugify';

export default {
  props: {
    
  },

  computed: {
    latestResults: function() {
      return this.posts.latest.slice(0, this.ui.visible);
    },
    filtersActive: function() {
      return this.filters.search_term !== '' || this.filters.sort_by !== 'most recent';
    },
    sidebarTitle: function() {
      let type = this.sidebarSettings.feed_type;
      if ( type == 'trending' ) {
        return 'TOP TRENDING';
      } else if (type == 'manual') {
        return 'RECOMMENDED';
      } else {
        return 'MOST RECENT';
      }
    },
    inclusions: function() {
      let type = this.sidebarSettings.feed_type;
      if (type == 'manual') {
        return this.lodash.map( this.sidebarSettings.inclusions, (inclusion) => {
          let parts = inclusion.post.split('-');
          return parseInt(parts[0]);
        } )
      }
    }
  },
  watch: {

  },
  components: {

  },
  filters: {
    filters: {
      deep: true,
      handler() {
        this.getPosts();
      }
    }
  },
  data() {
    return { 
      
      loading: true,
      filters: {
        search_term: '',
        sort_by: 'most recent'
      },
      ui: {
        page: 1,
        per_page: 3,
        visible: 6,
        storyCount: 0,
      },
      posts: {
        latest: [],
        trending: [],
      },
      sidebarSettings: sidebarSettings,
      postApiKey: postApiKey
     
    }
  },
  mounted() {

    let self = this;


    console.log('sidebar settings', this.sidebarSettings);

    console.log('inclusions', this.inclusions);

    this.getPosts(function() {


     /* window.addEventListener('scroll', function() {
        var scrollTop = document.documentElement.scrollTop + 10;
        if ( scrollTop > document.querySelector('.local-stories-sidebar').offsetTop ) {
          var offsetDiv = scrollTop - document.querySelector('.local-stories-sidebar').offsetTop;

          var sidebarHeight = document.querySelector('.local-stories-sidebar').offsetHeight;


          var stickyHeight = document.querySelector('.local-stories-sidebar .sticky-sidebar').offsetHeight;
          var sidebarStart = document.querySelector('.local-stories-sidebar').offsetTop;

          var stickyEnd = document.querySelector('.local-stories-sidebar .sticky-sidebar').offsetHeight + scrollTop;
          var sidebarEnd = document.querySelector('.local-stories-sidebar').offsetHeight + document.querySelector('.local-stories-sidebar').offsetTop;
          console.log('sidebar End:', sidebarEnd);

          if ( stickyEnd < sidebarEnd ) {
            $('.sticky-sidebar').css({ top: offsetDiv });
          }


        } else {
         $('.sticky-sidebar').css({ top: 0 });
        }
      });*/ 

    });
   
 

  },
  methods: {
    byViews: function(arr) {
      // Set slice() to avoid to generate an infinite loop!



      var final = arr.slice().sort(function(a, b) {

        return parseInt(b.num_views) - parseInt(a.num_views);
      });

      return final.slice(0, 6);
    },
    loadMore() {
      this.ui.visible += 6;
    },
    urlTitle: function(post) {

      return post.id + '-' + slugify(post.title, { remove: /[*+~.()'"!,:@]/g });

    },
    printDate(dt, ps, fm) {
      return format( parse(dt, ps, new Date()), fm );
    },
    clearSearch() {
      this.filters = {
        search_term: '',
        sort_by: 'most recent'
      };
      this.getPosts();
    },
    getPosts(callback) {



      let data = {
        //api_key: '092c303b01004fe53d118bc9a2a03a2f',
        api_key: this.postApiKey,
        page: this.ui.page,
        pp: 80,
        view_type: 'list',
        //search_domain: 'https://visitmeckva.com/local-stories',
        layout: 'grid',
        sort_by: this.filters.sort_by,
        show_featured: false,
        search_term: this.filters.search_term,
        view_type_default: 'grid',
      };

      let type = this.sidebarSettings.feed_type;
      if ( type == 'manual' ) {


        $.ajax({
            url: 'https://api.everwondr.com/ajax/get_included_posts', // or example_ajax_obj.ajaxurl if using on frontend
            data: { inclusions: this.inclusions },
            type: "POST",
            dataType: "json",
            success:(data) => {
                // This outputs the result of the ajax request
                this.posts.trending = data.items;

                callback();
            },
            error: function(errorThrown){
                console.log(errorThrown);
            }
        }); 

      }

      let url = 'https://api.everwondr.com/community/search_ajax';

      $.ajax({
          url: url, // or example_ajax_obj.ajaxurl if using on frontend
          data: { data: data },
          type: "POST",
          dataType: "json",
          success:(data) => {
              // This outputs the result of the ajax request
              this.posts.latest = data.items;

              this.ui.storyCount = data.count;

              callback();
          },
          error: function(errorThrown){
              console.log(errorThrown);
          }
      }); 

    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/LocalStories.vue